import React from 'react';
import { BsFacebook, BsInstagram } from 'react-icons/bs';
import { Link } from 'react-router-dom';

const Footer = () => {
  function handleSmoothScroll(){
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }
  return (
    <footer className="bg-gray-900 text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="flex justify-between flex-wrap gap-6">
          {/* Company Info */}
          <div>
            <h3 className="text-xl font-bold mb-4">Anu Offset Prints</h3>
            <p className="text-gray-400">
              Professional printing services for all your business needs.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-xl font-bold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" onClick={()=>handleSmoothScroll()} className="text-gray-400 hover:text-white">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/services" onClick={()=>handleSmoothScroll()} className="text-gray-400 hover:text-white">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/aboutUs" onClick={()=>handleSmoothScroll()} className="text-gray-400 hover:text-white">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/contact" onClick={()=>handleSmoothScroll()} className="text-gray-400 hover:text-white">
                  Contact
                </Link>
              </li>
              <li>
                <Link to="/blog" onClick={()=>handleSmoothScroll()} className="text-gray-400 hover:text-white">
                  Blog
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-xl font-bold mb-4">Our Services</h3>
            <ul className="space-y-2">
              <li>
                <Link className="text-gray-400 hover:text-white">
                  Graphics
                </Link>
              </li>
              <li>
                <Link className="text-gray-400 hover:text-white">
                  Digital Printing
                </Link>
              </li>
              <li>
                <Link className="text-gray-400 hover:text-white">
                  Offset Printing
                </Link>
              </li>
              <li>
                <Link className="text-gray-400 hover:text-white">
                  Corporate Gifts
                </Link>
              </li>
              <li>
                <Link className="text-gray-400 hover:text-white">
                  Signages
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-xl font-bold mb-4">Contact Us</h3>
            <ul className="space-y-2 text-gray-400">
              <li> C-12, (KSSIDC),</li>
              <li>KIADB Industrial Area Nanjungud - 571302</li>
              <li>Phone: 08221-225668, +91 95913 59048, +91 98869 25668</li>
              <li>Email: anuoffsetprinters2011@gmail.com</li>
              <li>
                <div className="flex space-x-3">
                  <div className="p-2 sm:p-2.5 rounded-full bg-secondary hover:bg-secondary transition-colors duration-200 cursor-pointer">
                    <BsFacebook className="text-white text-[20px]"/>
                  </div>
                  <div className="p-2 sm:p-2.5 rounded-full bg-secondary hover:secondary transition-all duration-200 cursor-pointer">
                    <BsInstagram className="text-white text-[20px]"/>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="flex flex-col sm:flex-row justify-between items-center text-center sm:text-left bg-primary mt-12 p-6 sm:p-8 text-gray-400 container mx-auto w-full max-w-[80%] rounded-lg">
          <p className="mb-4 sm:mb-0 text-sm sm:text-base">&copy; {new Date().getFullYear()} Copyright All Right Reserved Design By Anu offset Prints.</p>
          <p className="mb-4 sm:mb-0 text-sm sm:text-base">Developed by Ayrus Media.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 